export default __webpack_public_path__ + "static/media/_dots_small_icon.e4ca94fa.svg";